import Api from '@/services/Api'

export default {
    getAllInformacionFinanciera(){
        return Api().get('informacionFinanciera/getAll')
    },
    getInfoFinancieraById(id){
        return Api().get('informacionFinanciera/infoFinancieraById/'+id)
    },
    createInformacionFinaciera(datos){
        return Api().post('informacionFinanciera/create',datos)
    },
    updateInformacionFinanciera(datos){
        return Api().put('informacionFinanciera/update',datos)
    },
    // deleteTasa(id){
    //     return Api().delete('tasa/delete/'+id)
    // }
}